//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class WebhooksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    postApiWebhooksClerk(svixId: string | null | undefined, svixTimestamp: string | null | undefined, svixSignature: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/webhooks/clerk";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "svix-id": svixId !== undefined && svixId !== null ? "" + svixId : "",
                "svix-timestamp": svixTimestamp !== undefined && svixTimestamp !== null ? "" + svixTimestamp : "",
                "svix-signature": svixSignature !== undefined && svixSignature !== null ? "" + svixSignature : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiWebhooksClerk(_response);
        });
    }

    protected processPostApiWebhooksClerk(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UsersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    postApiUsers(request: CreateUserRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiUsers(_response);
        });
    }

    protected processPostApiUsers(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getApiUsers(pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Promise<UsersPagedDto> {
        let url_ = this.baseUrl + "/api/users?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiUsers(_response);
        });
    }

    protected processGetApiUsers(response: Response): Promise<UsersPagedDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UsersPagedDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UsersPagedDto>(null as any);
    }

    deleteApiUsers(userId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteApiUsers(_response);
        });
    }

    protected processDeleteApiUsers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getApiUsers2(userId: string): Promise<UserResponse> {
        let url_ = this.baseUrl + "/api/users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiUsers2(_response);
        });
    }

    protected processGetApiUsers2(response: Response): Promise<UserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserResponse>(null as any);
    }

    putApiUsers(userId: string, request: UpdateUserRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPutApiUsers(_response);
        });
    }

    protected processPutApiUsers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getApiUsersAdmin(userId: string): Promise<UserDetailDto> {
        let url_ = this.baseUrl + "/api/users/admin/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiUsersAdmin(_response);
        });
    }

    protected processGetApiUsersAdmin(response: Response): Promise<UserDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDetailDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailDto>(null as any);
    }

    getApiUsersMePermissions(): Promise<UserPermissionsResponse> {
        let url_ = this.baseUrl + "/api/users/me/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiUsersMePermissions(_response);
        });
    }

    protected processGetApiUsersMePermissions(response: Response): Promise<UserPermissionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserPermissionsResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserPermissionsResponse>(null as any);
    }
}

export class RolesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    postApiRoles(request: CreateRoleRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiRoles(_response);
        });
    }

    protected processPostApiRoles(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getApiRoles(pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Promise<RolesPagedDto> {
        let url_ = this.baseUrl + "/api/roles?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiRoles(_response);
        });
    }

    protected processGetApiRoles(response: Response): Promise<RolesPagedDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RolesPagedDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RolesPagedDto>(null as any);
    }

    deleteApiRoles(roleId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteApiRoles(_response);
        });
    }

    protected processDeleteApiRoles(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getApiRoles2(roleId: string): Promise<RoleDetailsDto> {
        let url_ = this.baseUrl + "/api/roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiRoles2(_response);
        });
    }

    protected processGetApiRoles2(response: Response): Promise<RoleDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleDetailsDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleDetailsDto>(null as any);
    }

    putApiRoles(roleId: string, request: UpdateRoleRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPutApiRoles(_response);
        });
    }

    protected processPutApiRoles(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getApiRolesPermissions(): Promise<RolePermissionDto[]> {
        let url_ = this.baseUrl + "/api/roles/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiRolesPermissions(_response);
        });
    }

    protected processGetApiRolesPermissions(response: Response): Promise<RolePermissionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RolePermissionDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RolePermissionDto[]>(null as any);
    }
}

export class ProjectsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getApiProjectsConflicts(projectId: string): Promise<ProjectConflictItem[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/conflicts";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiProjectsConflicts(_response);
        });
    }

    protected processGetApiProjectsConflicts(response: Response): Promise<ProjectConflictItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectConflictItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectConflictItem[]>(null as any);
    }

    postApiProjectsConflictsResolve(projectId: string, conflictId: string, request: ResolveRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/conflicts/{conflictId}/resolve";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (conflictId === undefined || conflictId === null)
            throw new globalThis.Error("The parameter 'conflictId' must be defined.");
        url_ = url_.replace("{conflictId}", encodeURIComponent("" + conflictId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiProjectsConflictsResolve(_response);
        });
    }

    protected processPostApiProjectsConflictsResolve(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getApiProjectsStakeholders(projectId: string): Promise<ProjectAccessResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stakeholders";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiProjectsStakeholders(_response);
        });
    }

    protected processGetApiProjectsStakeholders(response: Response): Promise<ProjectAccessResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectAccessResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectAccessResponse>(null as any);
    }

    postApiProjectsStakeholders(projectId: string, request: StakeholderRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stakeholders";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiProjectsStakeholders(_response);
        });
    }

    protected processPostApiProjectsStakeholders(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteApiProjects(projectId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteApiProjects(_response);
        });
    }

    protected processDeleteApiProjects(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getApiProjects(pageNumber: number | undefined, pageSize: number | undefined, search: string | null | undefined, conflictsOnly: boolean | null | undefined): Promise<ProjectListResult> {
        let url_ = this.baseUrl + "/api/projects?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (conflictsOnly !== undefined && conflictsOnly !== null)
            url_ += "conflictsOnly=" + encodeURIComponent("" + conflictsOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiProjects(_response);
        });
    }

    protected processGetApiProjects(response: Response): Promise<ProjectListResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectListResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectListResult>(null as any);
    }

    postApiProjects(request: CreateProjectRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiProjects(_response);
        });
    }

    protected processPostApiProjects(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getApiProjectsSummary(projectId: string): Promise<ProjectSummaryResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/summary";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiProjectsSummary(_response);
        });
    }

    protected processGetApiProjectsSummary(response: Response): Promise<ProjectSummaryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectSummaryResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectSummaryResponse>(null as any);
    }

    getApiDashboardSummary(): Promise<DashboardSummaryResponse> {
        let url_ = this.baseUrl + "/api/dashboard/summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiDashboardSummary(_response);
        });
    }

    protected processGetApiDashboardSummary(response: Response): Promise<DashboardSummaryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardSummaryResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardSummaryResponse>(null as any);
    }
}

export class ProcessingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getApiSettingsExtraction(): Promise<ExtractionSettingsResponse> {
        let url_ = this.baseUrl + "/api/settings/extraction";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiSettingsExtraction(_response);
        });
    }

    protected processGetApiSettingsExtraction(response: Response): Promise<ExtractionSettingsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExtractionSettingsResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExtractionSettingsResponse>(null as any);
    }

    putApiSettingsExtraction(request: UpdateExtractionSettingsCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/settings/extraction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPutApiSettingsExtraction(_response);
        });
    }

    protected processPutApiSettingsExtraction(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getApiOpsCost(): Promise<AiCostsResponse> {
        let url_ = this.baseUrl + "/api/ops/cost";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiOpsCost(_response);
        });
    }

    protected processGetApiOpsCost(response: Response): Promise<AiCostsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AiCostsResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AiCostsResponse>(null as any);
    }

    getApiProcessingJobs(pageNumber: number | undefined, pageSize: number | undefined, status: string | null | undefined): Promise<ProcessingJobsResult> {
        let url_ = this.baseUrl + "/api/processing/jobs?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiProcessingJobs(_response);
        });
    }

    protected processGetApiProcessingJobs(response: Response): Promise<ProcessingJobsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProcessingJobsResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessingJobsResult>(null as any);
    }

    getApiProcessingHoldingArea(pageNumber: number | undefined, pageSize: number | undefined): Promise<HoldingAreaResult> {
        let url_ = this.baseUrl + "/api/processing/holding-area?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiProcessingHoldingArea(_response);
        });
    }

    protected processGetApiProcessingHoldingArea(response: Response): Promise<HoldingAreaResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HoldingAreaResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HoldingAreaResult>(null as any);
    }

    postApiProcessingJobsRetry(jobId: string, request: RequeueJobRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/processing/jobs/{jobId}/retry";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiProcessingJobsRetry(_response);
        });
    }

    protected processPostApiProcessingJobsRetry(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    postApiProcessingJobsAbandon(jobId: string, request: AbandonJobRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/processing/jobs/{jobId}/abandon";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiProcessingJobsAbandon(_response);
        });
    }

    protected processPostApiProcessingJobsAbandon(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    postApiDocumentsFields(documentId: string, request: Request): Promise<string> {
        let url_ = this.baseUrl + "/api/documents/{documentId}/fields";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiDocumentsFields(_response);
        });
    }

    protected processPostApiDocumentsFields(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getApiDocumentsFields(documentId: string): Promise<DocumentFieldsResponse> {
        let url_ = this.baseUrl + "/api/documents/{documentId}/fields";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiDocumentsFields(_response);
        });
    }

    protected processGetApiDocumentsFields(response: Response): Promise<DocumentFieldsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentFieldsResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentFieldsResponse>(null as any);
    }

    postApiFieldsCorrect(fieldId: string, ifMatch: string | null | undefined, request: CorrectFieldRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/fields/{fieldId}/correct";
        if (fieldId === undefined || fieldId === null)
            throw new globalThis.Error("The parameter 'fieldId' must be defined.");
        url_ = url_.replace("{fieldId}", encodeURIComponent("" + fieldId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "If-Match": ifMatch !== undefined && ifMatch !== null ? "" + ifMatch : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiFieldsCorrect(_response);
        });
    }

    protected processPostApiFieldsCorrect(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 428) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    postApiFieldsBulkVerify(request: BulkVerifyFieldsRequest): Promise<BulkVerifyResult> {
        let url_ = this.baseUrl + "/api/fields/bulk-verify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiFieldsBulkVerify(_response);
        });
    }

    protected processPostApiFieldsBulkVerify(response: Response): Promise<BulkVerifyResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkVerifyResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkVerifyResult>(null as any);
    }

    postApiFieldsVerify(fieldId: string, ifMatch: string | null | undefined, request: VerifyFieldRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/fields/{fieldId}/verify";
        if (fieldId === undefined || fieldId === null)
            throw new globalThis.Error("The parameter 'fieldId' must be defined.");
        url_ = url_.replace("{fieldId}", encodeURIComponent("" + fieldId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "If-Match": ifMatch !== undefined && ifMatch !== null ? "" + ifMatch : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiFieldsVerify(_response);
        });
    }

    protected processPostApiFieldsVerify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 428) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getApiFieldsHistory(fieldId: string): Promise<FieldHistoryItem[]> {
        let url_ = this.baseUrl + "/api/fields/{fieldId}/history";
        if (fieldId === undefined || fieldId === null)
            throw new globalThis.Error("The parameter 'fieldId' must be defined.");
        url_ = url_.replace("{fieldId}", encodeURIComponent("" + fieldId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiFieldsHistory(_response);
        });
    }

    protected processGetApiFieldsHistory(response: Response): Promise<FieldHistoryItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FieldHistoryItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FieldHistoryItem[]>(null as any);
    }
}

export class DocumentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    postApiDocumentsUpload(iFormFile: Blob): Promise<UploadBatchResponse> {
        let url_ = this.baseUrl + "/api/documents/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = iFormFile;

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/octet-stream",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiDocumentsUpload(_response);
        });
    }

    protected processPostApiDocumentsUpload(response: Response): Promise<UploadBatchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UploadBatchResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UploadBatchResponse>(null as any);
    }

    getApiUploadsBatches(batchId: string): Promise<UploadBatchStatusResponse> {
        let url_ = this.baseUrl + "/api/uploads/batches/{batchId}";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiUploadsBatches(_response);
        });
    }

    protected processGetApiUploadsBatches(response: Response): Promise<UploadBatchStatusResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UploadBatchStatusResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UploadBatchStatusResponse>(null as any);
    }

    getApiUploadsBatches2(pageNumber: number | undefined, pageSize: number | undefined): Promise<UploadBatchesResult> {
        let url_ = this.baseUrl + "/api/uploads/batches?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiUploadsBatches2(_response);
        });
    }

    protected processGetApiUploadsBatches2(response: Response): Promise<UploadBatchesResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UploadBatchesResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UploadBatchesResult>(null as any);
    }

    getApiProjectsDocumentsZip(projectId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/documents/zip";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiProjectsDocumentsZip(_response);
        });
    }

    protected processGetApiProjectsDocumentsZip(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getApiDocumentsContent(documentId: string): Promise<DocumentContentResponse> {
        let url_ = this.baseUrl + "/api/documents/{documentId}/content";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiDocumentsContent(_response);
        });
    }

    protected processGetApiDocumentsContent(response: Response): Promise<DocumentContentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentContentResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentContentResponse>(null as any);
    }

    getApiDocumentsFile(documentId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/documents/{documentId}/file";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiDocumentsFile(_response);
        });
    }

    protected processGetApiDocumentsFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getApiDocumentsUnfiled(pageNumber: number | undefined, pageSize: number | undefined): Promise<UnfiledDocumentsResult> {
        let url_ = this.baseUrl + "/api/documents/unfiled?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiDocumentsUnfiled(_response);
        });
    }

    protected processGetApiDocumentsUnfiled(response: Response): Promise<UnfiledDocumentsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnfiledDocumentsResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnfiledDocumentsResult>(null as any);
    }

    postApiDocumentsRefile(documentId: string, request: RefileDocumentRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/documents/{documentId}/refile";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiDocumentsRefile(_response);
        });
    }

    protected processPostApiDocumentsRefile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AdminClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getApiAdminAuditLog(userId: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined, entityName: string | null | undefined, entityId: string | null | undefined, operation: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<AuditLogResultDto> {
        let url_ = this.baseUrl + "/api/admin/audit-log?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (entityName !== undefined && entityName !== null)
            url_ += "entityName=" + encodeURIComponent("" + entityName) + "&";
        if (entityId !== undefined && entityId !== null)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        if (operation !== undefined && operation !== null)
            url_ += "operation=" + encodeURIComponent("" + operation) + "&";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiAdminAuditLog(_response);
        });
    }

    protected processGetApiAdminAuditLog(response: Response): Promise<AuditLogResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuditLogResultDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuditLogResultDto>(null as any);
    }
}

export interface CreateUserRequest {
    email?: string;
    firstName?: string;
    lastName?: string;
    roleIds?: string[];
    companyName?: string | undefined;
}

export interface UsersPagedDto {
    items?: UserDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export interface UserDto {
    id?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    companyName?: string | undefined;
    isActive?: boolean;
    roles?: UserRoleDto[];
}

export interface UserRoleDto {
    roleId?: string;
    roleName?: string;
}

export interface UserResponse {
    id?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
}

export interface UserDetailDto {
    id?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    companyName?: string | undefined;
    isActive?: boolean;
    roleIds?: string[];
    roleNames?: string[];
}

export interface UserPermissionsResponse {
    userId?: string;
    email?: string;
    permissions?: string[];
}

export interface UpdateUserRequest {
    email?: string;
    firstName?: string;
    lastName?: string;
    roleIds?: string[];
    companyName?: string | undefined;
}

export interface CreateRoleRequest {
    name?: string;
    description?: string | undefined;
    permissionIds?: string[] | undefined;
}

export interface RolesPagedDto {
    items?: RoleSummaryDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export interface RoleSummaryDto {
    id?: string;
    name?: string;
    description?: string | undefined;
    permissionCount?: number;
    permissions?: string[];
}

export interface RoleDetailsDto {
    id?: string;
    name?: string;
    description?: string | undefined;
    permissionIds?: string[];
}

export interface RolePermissionDto {
    id?: string;
    action?: string;
    description?: string | undefined;
}

export interface UpdateRoleRequest {
    name?: string;
    description?: string | undefined;
    permissionIds?: string[] | undefined;
}

export interface ProjectConflictItem {
    id?: string;
    version?: string;
    rule?: string;
    relatedProjectId?: string | undefined;
    isActive?: boolean;
    detectedAt?: Date;
    evidence?: ConflictEvidence[];
    resolution?: ConflictResolutionItem | undefined;
}

export interface ConflictEvidence {
    documentId?: string | undefined;
    fieldId?: string | undefined;
    fieldKey?: string;
    value?: string;
}

export interface ConflictResolutionItem {
    actorUserId?: string;
    actorName?: string;
    resolvedAt?: Date;
    decision?: string;
    notes?: string;
    documentId?: string | undefined;
    destinationProjectId?: string | undefined;
}

export interface ResolveRequest {
    expectedVersion?: string;
    decision?: string;
    notes?: string;
    documentId?: string | undefined;
    destinationProjectId?: string | undefined;
}

export interface ProjectAccessResponse {
    canManage?: boolean;
    members?: ProjectStakeholderItem[];
}

export interface ProjectStakeholderItem {
    userId?: string;
    name?: string;
    isCreator?: boolean;
}

export interface StakeholderRequest {
    userId?: string;
    remove?: boolean;
    email?: string | undefined;
}

export interface ProjectListResult {
    items?: ProjectListItem[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export interface ProjectListItem {
    id?: string;
    internalReference?: string;
    projectNumber?: string | undefined;
    externalReference?: string | undefined;
    externalClientName?: string | undefined;
    cargoDescription?: string | undefined;
    vesselName?: string | undefined;
    status?: string;
    conflictStatus?: string;
    documentCount?: number;
    needsReviewCount?: number;
    createdAt?: Date;
}

export interface CreateProjectRequest {
    externalReference?: string | undefined;
    externalClientName?: string | undefined;
    cargoDescription?: string | undefined;
    externalCompanyName?: string | undefined;
}

export interface ProjectSummaryResponse {
    id?: string;
    internalReference?: string;
    projectNumber?: string | undefined;
    externalReference?: string | undefined;
    externalClientName?: string | undefined;
    cargoDescription?: string | undefined;
    vesselName?: string | undefined;
    status?: string;
    conflictStatus?: string;
    documents?: ProjectDocumentItem[];
    extractedFields?: ProjectFieldItem[];
    uploadPacks?: ProjectGroupingItem[];
    overview?: ProjectOverviewItem[];
    externalCompanyName?: string | undefined;
}

export interface ProjectDocumentItem {
    documentId?: string;
    fileName?: string;
    documentTypeCode?: string | undefined;
    documentTypeName?: string | undefined;
    status?: string;
    isPhoto?: boolean;
    fieldCount?: number | undefined;
}

export interface ProjectFieldItem {
    fieldId?: string;
    documentId?: string;
    fileName?: string;
    fieldKey?: string;
    displayLabel?: string | undefined;
    rawValue?: string | undefined;
    confidence?: number | undefined;
    status?: string;
    dateAmbiguous?: boolean;
}

export interface ProjectGroupingItem {
    batchId?: string;
    rule?: string | undefined;
    groupedAt?: Date | undefined;
}

export interface ProjectOverviewItem {
    fieldKey?: string;
    values?: ProjectOverviewValue[];
}

export interface ProjectOverviewValue {
    value?: string;
    fieldIds?: string[];
    documentIds?: string[];
}

export interface ExtractionSettingsResponse {
    autoVerifyThreshold?: number;
    monthlyCapGbp?: number | undefined;
    perBatchCapGbp?: number | undefined;
    version?: string;
    history?: ExtractionSettingChange[];
}

export interface ExtractionSettingChange {
    key?: string;
    previousValue?: string | undefined;
    newValue?: string;
    changedAt?: Date;
    actorUserId?: string;
}

export interface UpdateExtractionSettingsCommand {
    autoVerifyThreshold?: number;
    monthlyCapGbp?: number | undefined;
    perBatchCapGbp?: number | undefined;
    expectedVersion?: string;
}

export interface AiCostsResponse {
    monthlyCostGbp?: number;
    monthlyCapGbp?: number | undefined;
    perBatchCapGbp?: number | undefined;
    heldJobCount?: number;
    batches?: AiBatchCost[];
}

export interface AiBatchCost {
    batchId?: string;
    uploadedAt?: Date;
    costGbp?: number;
    promptTokens?: number;
    completionTokens?: number;
}

export interface ProcessingJobsResult {
    items?: ProcessingJobItem[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    counts?: ProcessingJobCounts;
}

export interface ProcessingJobItem {
    jobId?: string;
    documentId?: string;
    fileName?: string;
    projectInternalReference?: string | undefined;
    documentStatus?: string;
    jobStatus?: string;
    currentStage?: string | undefined;
    lastError?: string | undefined;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;
    deadLetteredAt?: Date | undefined;
    attemptCount?: number;
}

export interface ProcessingJobCounts {
    inProgress?: number;
    awaitingReview?: number;
    failed?: number;
    succeeded?: number;
}

export interface HoldingAreaResult {
    items?: HoldingAreaItem[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export interface HoldingAreaItem {
    jobId?: string;
    documentId?: string;
    fileName?: string | undefined;
    currentStage?: string | undefined;
    lastError?: string | undefined;
    deadLetteredAt?: Date | undefined;
    holdingAreaStatus?: string | undefined;
}

export interface RequeueJobRequest {
    reason?: string;
}

export interface AbandonJobRequest {
    reason?: string;
}

export interface UploadBatchResponse {
    batchId?: string;
    correlationId?: string;
    documents?: UploadedDocumentItem[];
}

export interface UploadedDocumentItem {
    documentId?: string;
    fileName?: string;
    status?: string;
}

export interface UploadBatchStatusResponse {
    batchId?: string;
    correlationId?: string;
    status?: string;
    createdAt?: Date;
    completedAt?: Date | undefined;
    clientReference?: string | undefined;
    targetProjectId?: string | undefined;
    files?: UploadBatchFileStatus[];
    groupedProjectId?: string | undefined;
    groupedProjectInternalReference?: string | undefined;
    groupedProjectCargoDescription?: string | undefined;
    groupingRule?: string | undefined;
}

export interface UploadBatchFileStatus {
    documentId?: string;
    fileName?: string;
    documentStatus?: string;
    documentTypeCode?: string | undefined;
    projectId?: string | undefined;
    jobId?: string | undefined;
    jobStatus?: string | undefined;
    currentStage?: string | undefined;
    fieldCount?: number | undefined;
    lastError?: string | undefined;
}

export interface UploadBatchesResult {
    items?: UploadBatchStatusResponse[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export interface Request {
    fieldDefinitionId?: string;
    value?: string;
    qualifier?: string | undefined;
    pageNumber?: number | undefined;
    reason?: string;
}

export interface DocumentFieldsResponse {
    documentId?: string;
    fileName?: string;
    documentTypeCode?: string | undefined;
    status?: string;
    fields?: ExtractedFieldItem[];
    projectId?: string | undefined;
    projectReference?: string | undefined;
    vesselName?: string | undefined;
    availableFields?: ManualFieldDefinition[] | undefined;
}

export interface ExtractedFieldItem {
    id?: string;
    fieldKey?: string;
    displayLabel?: string | undefined;
    rawValue?: string | undefined;
    confidence?: number | undefined;
    status?: string;
    dateAmbiguous?: boolean;
    valueDate?: Date | undefined;
    valueNumber?: number | undefined;
    pageNumber?: number | undefined;
    autoVerified?: boolean;
    rowVersion?: string;
    boundingBox?: FieldBoundingBox | undefined;
    fieldDefinitionId?: string | undefined;
    dataType?: string | undefined;
}

export interface FieldBoundingBox {
    x?: number;
    y?: number;
    width?: number;
    height?: number;
    unit?: string;
}

export interface ManualFieldDefinition {
    id?: string;
    fieldKey?: string;
    displayLabel?: string;
    dataType?: string;
    unit?: string | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    allowedValuesJson?: string | undefined;
    documentTypeCode?: string;
}

export interface CorrectFieldRequest {
    newRawValue?: string | undefined;
    clearValue?: boolean;
    overrideDate?: string | undefined;
    reason?: string | undefined;
}

export interface BulkVerifyResult {
    verifiedCount?: number;
    threshold?: number;
}

export interface BulkVerifyFieldsRequest {
    documentId?: string | undefined;
    projectId?: string | undefined;
    thresholdOverride?: number | undefined;
}

export interface VerifyFieldRequest {
    reason?: string | undefined;
}

export interface FieldHistoryItem {
    id?: string;
    action?: string;
    previousRawValue?: string | undefined;
    newRawValue?: string | undefined;
    reason?: string | undefined;
    timestamp?: Date;
}

export interface DocumentContentResponse {
    documentId?: string;
    fileName?: string;
    mimeType?: string;
    downloadUrl?: string;
    expiresAt?: Date;
}

export interface UnfiledDocumentsResult {
    items?: UnfiledDocumentItem[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export interface UnfiledDocumentItem {
    documentId?: string;
    fileName?: string;
    documentTypeCode?: string | undefined;
    status?: string;
    createdAt?: Date;
}

export interface RefileDocumentRequest {
    projectId?: string;
}

export interface DashboardSummaryResponse {
    projectCount?: number;
    unfiledCount?: number;
    needsReviewCount?: number;
    inProgressJobCount?: number;
    failedJobCount?: number;
}

export interface AuditLogResultDto {
    logs?: AuditLogDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export interface AuditLogDto {
    id?: string;
    entityName?: string;
    entityId?: string;
    operation?: string;
    changes?: string;
    userId?: string | undefined;
    userName?: string | undefined;
    timestamp?: Date;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}